import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { GeneralModalComponent } from "../../../modals/general/general-modal/general-modal.component";
import { Contract } from "../../../classes/contract";
import { ContractService } from "../../../services/contract";

@Component({
  selector: 'app-checklist-general',
  templateUrl: './contract-general.component.html',
  styleUrls: ['./contract-general.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class ContractGeneralComponent implements OnInit {

  // Pagination Parameters
  paginationConfig = {
    itemsPerPage: 10,
    currentPage: 1
  };
  paginationParams = {
    autoHide: true,
    maxSize: 7,
    responsive: true
  };
  paginationLabels = {
    previousLabel: 'Precedente',
    nextLabel: 'Successiva',
    screenReaderPaginationLabel: 'Paginazione',
    screenReaderPageLabel: 'pagina',
    screenReaderCurrentLabel: `Sei sulla pagina`
  };

  // Filters
  contractFilterValue!: string;
  contractCodeFilterValue!: string;
  contractTitleFilterValue!: string;
  contractChecklistFilterValue!: string;

  // Contracts data
  contracts: Array<Contract> = [];

  constructor(private contractService: ContractService,
              private modalService: NgbModal) { }

  ngOnInit(): void {
    this.contractService.getAll()
      .pipe(
        switchMap((contractsData: any) => from(contractsData))
      )
      .subscribe({
        next: (contract: any) => {
          this.contracts.push(contract);
        },
        error: e => {
          console.log('Error: ' + e);
        }
      });
  }

  onPageChange(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  onPageBoundsCorrection(pageNumber: number) {
    this.paginationConfig.currentPage = pageNumber;
  }

  openDeleteContractModal(contract: Contract) {
    const modalRef = this.modalService.open(GeneralModalComponent);
    modalRef.componentInstance.title = 'Rimozione <strong>Convenzione</strong>';
    modalRef.componentInstance.text = 'Confermi la rimozione della convenzione "' + contract.name + '"?';
    modalRef.result.then(() => {
      if (contract.id_contract) {
        this.contractService.delete(contract.id_contract)
            .subscribe({
              next: () => {
                this.contracts = this.contracts.filter((currContract: Contract) => currContract.id_contract !== contract.id_contract);
                this.paginationConfig.currentPage = 1;
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            });
      }
    });
  }

}
